import {
  Curriculum,
  useCurriculum,
} from "@twinkltech/curriculum-architect-domain-hooks";

import { DeleteCurriculumModal } from "./DeleteCurriculumModal";

export const DeleteCurriculumModalContainer = ({
  curriculum,
  error = null,
  loading = false,
  onClose,
  open,
  shouldRedirectOnAction = false,
}: {
  curriculum?: Curriculum | null;
  error?: Error | null;
  loading?: boolean;
  onClose: () => void;
  open: boolean;
  shouldRedirectOnAction?: boolean;
}) => {
  const {
    actions: { delete: deleteCurriculum },
  } = useCurriculum();

  return (
    <DeleteCurriculumModal
      curriculum={curriculum}
      error={error}
      loading={loading}
      open={open}
      shouldRedirectOnAction={shouldRedirectOnAction}
      onClose={onClose}
      onSubmit={deleteCurriculum.apply}
    />
  );
};
